import React from "react";
import { Grid, Skeleton } from "@mui/material";

const TableRowSkeleton: React.FC = (props) => {
  return (
    <Grid
      direction="row"
      container
      item
      padding={2}
      paddingRight={3}
      justifyContent="space-between"
      alignItems="center"
      height={"56px"}
      width={"100%"}
    >
      <Grid item container xs={3} gap={2} alignItems="center">
        <Skeleton variant="circular" width="20px" height="20px" />
        <Grid item width={"auto"} flexGrow={1}>
          <Skeleton variant="rounded" width="auto" height="8px" />
        </Grid>
      </Grid>
      <Grid item xs={2}>
        <Skeleton variant="rounded" width="100%" height="8px" />
      </Grid>
      <Grid item xs={2}>
        <Skeleton variant="rounded" width="100%" height="8px" />
      </Grid>
      <Grid item xs={2}>
        <Skeleton variant="rounded" width="100%" height="8px" />
      </Grid>
    </Grid>
  );
};

export default TableRowSkeleton;
